/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBug = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 13V9h10v4c0 2.757-2.243 5-5 5s-5-2.243-5-5zm8-6H9c0-1.654 1.346-3 3-3s3 1.346 3 3zm7 7v-2h-3V8.857c1.72-.446 3-1.999 3-3.857V2h-2v3c0 1.103-.897 2-2 2h-1c0-2.757-2.243-5-5-5S7 4.243 7 7H6c-1.103 0-2-.897-2-2V2H2v3c0 1.858 1.28 3.411 3 3.857V12H2v2h3.08c.064.441.167.869.309 1.281a4.85 4.85 0 0 0-1.505.885C2.687 17.19 2 18.787 2 20.546V22h2v-1.454c0-1.174.432-2.217 1.184-2.86a2.747 2.747 0 0 1 1.147-.596C7.604 18.849 9.668 20 12 20s4.396-1.151 5.669-2.91c.411.101.793.293 1.147.596.752.643 1.184 1.686 1.184 2.86V22h2v-1.454c0-1.759-.687-3.356-1.884-4.38a4.85 4.85 0 0 0-1.505-.885A7.02 7.02 0 0 0 18.92 14z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBug as Bug };
